module.exports = __webpack_public_path__ + "img/DE01563.cf7eddba.png";